import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { CustomerSummary, DataBusLicense, DataBusStatus } from 'src/api/models';
import { CustomerService, DataBusService } from 'src/api/services';
import { ApplicationConfigService } from 'src/service/application-config.service';

@Component({
  selector: 'app-databus-approve',
  templateUrl: './databus-approve.component.html',
  styleUrls: ['./databus-approve.component.css']
})
export class DatabusApproveComponent implements OnInit {

  public newOrders: DataBusLicense[] = new Array<DataBusLicense>();
  public approvedOrders: DataBusLicense[] = new Array<DataBusLicense>();
  // create a date value that is 1 hour older than the current time
  public oneHourAgo: Date = new Date(new Date().getTime() - 3600000);
  public inOneMonth: Date = new Date(new Date().getTime() + 3600000*24*30);
  public inTwoMonth: Date = new Date(new Date().getTime() - 3600000*24*60);
  // add method to convert string date to Date object
  public convertToDate(dateString: string): Date {
    return new Date(dateString);
  }
  public toList(plugins: string[]): string {
    return plugins.join(',\n ');
  } 

  constructor(
    private dataBusService: DataBusService,
        private customerService: CustomerService,
        private toast: ToastrService,
        private app: ApplicationConfigService,
    private route: Router) {}

  statuses : DataBusStatus[];
  customers: CustomerSummary[];

  // Sorting state for each table
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  sortColumnWithout: string = '';
  sortDirectionWithout: 'asc' | 'desc' = 'asc';
  sortColumnExpired: string = '';
  sortDirectionExpired: 'asc' | 'desc' = 'asc';
  sortColumnActive: string = '';
  sortDirectionActive: 'asc' | 'desc' = 'asc';

  ngOnInit(): void {
    this.getOrders();
    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
    this.dataBusService.DataBusGetDataBusStatusList().subscribe(s =>{
      this.statuses = s;    
    });
    this.customerService.CustomerGetAllCustomers().subscribe(r => {
      this.customers = r;
    })
  }

  validFor: number;
  customerId: number;
  selectedDataBus: DataBusStatus;
  public showCreateLicense(status: DataBusStatus){
    this.selectedDataBus = status;
    this.validFor = 365;
    this.customerId = null;
  }

  createLicense(customerId: number, db: DataBusStatus, validFor: number){
    this.dataBusService.DataBusConvertToLicense({
      customerId:customerId,
      dataBusStatusId:db.dataBusStatusId,
      validFor:validFor}).subscribe(r => {
        this.toast.success("Converted...");
        // Refresh orders and statuses to show the new license
        this.getOrders();
        this.dataBusService.DataBusGetDataBusStatusList().subscribe(s =>{
          this.statuses = s;
        });
    });
  }

  deleteStatus(db: DataBusStatus){
    this.dataBusService.DataBusDeleteDataBusStatus(db.dataBusStatusId).subscribe(r => {
      this.toast.success("Status Removed");
      // remove db from this.statuses
      this.statuses = this.statuses.filter(s => s.dataBusStatusId !== db.dataBusStatusId);

    }, err => {
      this.toast.error("Error removing status");
    })
  }

    deleteLicense(db: DataBusLicense){
    this.dataBusService.DataBusDeleteDataBusLicense(db.licenseId).subscribe(r => {
      this.toast.success("Status Removed");
      // remove db from this.statuses
      this.approvedOrders = this.approvedOrders.filter(s => s.licenseId !== db.licenseId);
      this.newOrders = this.newOrders.filter(s => s.licenseId !== db.licenseId);

    }, err => {
      this.toast.error("Error removing status");
    })
  }

  changeOrderStatus() {
    if (this.newOrders.length > 0) {
      for (const order of this.newOrders) {
        (order as any).validDays = 365;
        //this.changeDate(order, 365);
        // todo - this should be using the enum generated by SwaggerGen - James
        // todo - not being parsed an order status.
        // var index = parseInt(order.orderStatus);
        // if (index === 0)
        // {
        //   order.orderStatus = "PENNDING";
        // }
        // else if (index === 1)
        // {
        //   order.orderStatus = "PROCESSING";
        // }
        // else if (index === 2)
        // {
        //   order.orderStatus = "PAID";
        // }
      }
    }
  }

  addDays(days) {
    //var result = new Date();
    //result.setDate(result.getDate() + days);
    //return result;
    var ms = new Date().getTime() + (86400000 * days);
    var tomorrow = new Date(ms);
    return tomorrow;
  }

  changeDate(order, event){
    //console.log(event.target.value);
    order.validDayCalc = this.addDays(event.target.value);
    order.validDays = event.target.value;
  }


  approveOrder(order: DataBusLicense) {

    // todo - update new pending order.
    // todo - LicenseOrderModel class no longer has id.
    //alert((order as any).validToDate);
    this.dataBusService.DataBusApproveOrder({ orderId: order.licenseId, validDays: (order as any).validDays })
      .subscribe(
        res => {
          // todo - instead of calling getOrders() which recalls for the order data, update the lists locally. - James
          this.getOrders();
        },
        err => {
          console.log(err);
        }
      );
  }

  revokeOrder(order: DataBusLicense) {
    console.log("Revoking...");
    //todo: implement call to revoke a license
    this.dataBusService.DataBusRevokeLicense({customerId: this.app.customerId, licenseId: order.licenseId}).subscribe(r => {
      order.licenseStatus = r.licenseStatus;
    });
  }


  getOrders() {
    this.dataBusService.DataBusGetAllNewOrders()
      .subscribe(
        res => {
          this.newOrders = res;
          this.changeOrderStatus();
        },
        err => {
          this.newOrders = [];
          console.log(err);
        }
      );

    this.dataBusService.DataBusGetAllPaidOrders()
      .subscribe(
        res => {
          this.approvedOrders = res;
        },
        err => {
          console.log(err);
        }
      );
  }

  // Filter instances into three categories
  get instancesWithoutLicenses(): DataBusStatus[] {
    if (!this.statuses) return [];
    return this.sortInstances(
      this.statuses.filter(s => s.installedLicenseId == null),
      this.sortColumnWithout,
      this.sortDirectionWithout
    );
  }

  get instancesWithExpiredLicenses(): DataBusStatus[] {
    if (!this.statuses) return [];
    const now = new Date();
    return this.sortInstances(
      this.statuses.filter(s => s.installedLicenseId != null && s.expiry && this.convertToDate(s.expiry) < now),
      this.sortColumnExpired,
      this.sortDirectionExpired
    );
  }

  get instancesWithActiveLicenses(): DataBusStatus[] {
    if (!this.statuses) return [];
    const now = new Date();
    return this.sortInstances(
      this.statuses.filter(s => s.installedLicenseId != null && (!s.expiry || this.convertToDate(s.expiry) >= now)),
      this.sortColumnActive,
      this.sortDirectionActive
    );
  }

  // Sort instances by column
  sortInstances(instances: DataBusStatus[], column: string, direction: 'asc' | 'desc'): DataBusStatus[] {
    if (!column) return instances;

    return [...instances].sort((a, b) => {
      let aValue: any;
      let bValue: any;

      switch(column) {
        case 'computerName':
          aValue = a.computerName?.toLowerCase() || '';
          bValue = b.computerName?.toLowerCase() || '';
          break;
        case 'customerName':
          aValue = a.customerName?.toLowerCase() || '';
          bValue = b.customerName?.toLowerCase() || '';
          break;
        case 'expiry':
          aValue = a.expiry ? new Date(a.expiry).getTime() : 0;
          bValue = b.expiry ? new Date(b.expiry).getTime() : 0;
          break;
        case 'startTime':
          aValue = new Date(a.startTime).getTime();
          bValue = new Date(b.startTime).getTime();
          break;
        case 'timeStamp':
          aValue = new Date(a.timeStamp).getTime();
          bValue = new Date(b.timeStamp).getTime();
          break;
        case 'version':
          aValue = a.version?.toLowerCase() || '';
          bValue = b.version?.toLowerCase() || '';
          break;
        case 'errorCount':
          aValue = a.errorCount;
          bValue = b.errorCount;
          break;
        case 'totalUris':
          aValue = a.totalUris;
          bValue = b.totalUris;
          break;
        case 'plugins':
          aValue = a.plugins?.length || 0;
          bValue = b.plugins?.length || 0;
          break;
        default:
          return 0;
      }

      if (aValue < bValue) return direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return direction === 'asc' ? 1 : -1;
      return 0;
    });
  }

  // Sort handlers for each table
  sortTable(table: 'without' | 'expired' | 'active', column: string): void {
    if (table === 'without') {
      if (this.sortColumnWithout === column) {
        this.sortDirectionWithout = this.sortDirectionWithout === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumnWithout = column;
        this.sortDirectionWithout = 'asc';
      }
    } else if (table === 'expired') {
      if (this.sortColumnExpired === column) {
        this.sortDirectionExpired = this.sortDirectionExpired === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumnExpired = column;
        this.sortDirectionExpired = 'asc';
      }
    } else if (table === 'active') {
      if (this.sortColumnActive === column) {
        this.sortDirectionActive = this.sortDirectionActive === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumnActive = column;
        this.sortDirectionActive = 'asc';
      }
    }
  }

  // Get sort indicator icon
  getSortIcon(table: 'without' | 'expired' | 'active', column: string): string {
    let currentColumn = '';
    let currentDirection: 'asc' | 'desc' = 'asc';

    if (table === 'without') {
      currentColumn = this.sortColumnWithout;
      currentDirection = this.sortDirectionWithout;
    } else if (table === 'expired') {
      currentColumn = this.sortColumnExpired;
      currentDirection = this.sortDirectionExpired;
    } else if (table === 'active') {
      currentColumn = this.sortColumnActive;
      currentDirection = this.sortDirectionActive;
    }

    if (currentColumn !== column) return '';
    return currentDirection === 'asc' ? '▲' : '▼';
  }
}
